import React from 'react';

import {cls} from '../../../../components/utils';

import css from './sheet.module.css';

type Props = {
	title?: string;
	/** карточка как у характеристик: мелкий заголовок заглавными по центру */
	card?: boolean;
	className?: string;
	children: React.ReactNode;
};

export const SheetBlock: React.FC<Props> = ({title, card, className, children}) => (
	<section className={cls(card ? css.ability : css.block, className)}>
		{title && (card ? <h3 className={css.abilityName}>{title}</h3> : <h2 className={css.blockTitle}>{title}</h2>)}
		{children}
	</section>
);

type FactProps = {
	label: string;
	children: React.ReactNode;
};

export const Fact: React.FC<FactProps> = ({label, children}) => (
	<div className={css.fact}>
		<dt>{label}</dt>
		<dd>{children}</dd>
	</div>
);
